import React from "react";
import { useTimeline } from "../../../../context/TimelineProvider";
import moment from "moment";

const formatDuration = (seconds) => {
  const duration = moment.duration(seconds, "seconds");
  const hours = Math.floor(duration.asHours()).toString().padStart(2, "0");
  const minutes = duration.minutes().toString().padStart(2, "0");
  const secs = duration.seconds().toString().padStart(2, "0");

  return `${hours}:${minutes}:${secs}`;
};

const Tooltip = ({ divisionId }) => {
  const { segmentTooltipData, tooltipPosition, removeSegmentTooltip } =
    useTimeline(divisionId);

  const closeTooltip = () => {
    removeSegmentTooltip();
  };

  return (
    <div
      style={{
        position: "absolute",
        top: tooltipPosition.top,
        left: tooltipPosition.left,
        backgroundColor: "#fff",
        border: "1px solid #000",
        padding: "10px",
        zIndex: 1000,
        transform: "translate(-50%, -100%)",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        minWidth: "300px",
        userSelect: "none",
      }}
    >
      <button
        style={{
          position: "absolute",
          top: "5px",
          right: "5px",
          background: "none",
          border: "none",
          fontSize: "16px",
          fontWeight: "bold",
          cursor: "pointer",
        }}
        onClick={closeTooltip}
      >
        ×
      </button>
      <div>
        <strong>Заказ:</strong> {segmentTooltipData.order}
      </div>
      <div>
        <strong>Операция:</strong> {segmentTooltipData.operation}
      </div>
      <div>
        <strong>Количество:</strong> {segmentTooltipData.quantity}
      </div>
      <div>
        <strong>Начало:</strong> {segmentTooltipData.start}
      </div>
      <div>
        <strong>Окончание:</strong> {segmentTooltipData.end}
      </div>
      <div>
        <strong>Длительность:</strong>{" "}
        {formatDuration(segmentTooltipData.duration)}
      </div>
    </div>
  );
};

export default Tooltip;
